<template>
  <div class="ts-border ts-p-2 ts-rounded-md ts-h-full ts-overflow-auto right-box">
    <table class="ts-w-full">
      <thead>
        <tr class="ts-border-b">
          <th>{{ $t('productAssembly.item') }}</th>
          <th class="ts-w-32 ts-px-3">{{$t('productAssembly.quantity')}}</th>
          <th class="ts-w-1">{{ $t('actions') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in model.other_product_id_list" :key="index">
          <td>
            <select disabled v-model.number="item.other_sale_code_id">
              <option
                v-for="item in noneAssemblyProduct"
                :key="item.pro_sale_code_id"
                :value="item.pro_sale_code_id"
              >{{ item.name }}</option>
            </select>
						<div
              class="validate"
              v-if="errors.has('other_product_id_list.' + index + '.other_sale_code_id')"
            >{{ errors.first('other_product_id_list.' + index + '.other_sale_code_id') }}</div>
          </td>
          <td>
            <input
              type="number"
							min="1"
              class="ts-w-32 text-center ts-outline-none"
              v-model.number="item.quantity"
            />
            <div
              class="validate"
              v-if="errors.has('other_product_id_list.' + index + '.quantity')"
            >{{ errors.first('other_product_id_list.' + index + '.quantity') }}</div>
          </td>
          <td class="ts-text-center">
            <a href="#" @click.prevent="remove(index)" class="ts-text-red-600">
              <i class="fa fa-times"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    noneAssemblyProduct() {
      return this.$store.state.product.assembly.productAssembly.filter(
        a => a.product_type_id != 1
      )
    }
  },
  methods: {
    remove(index) {
      this.model.other_product_id_list.splice(index, 1)
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style>
.right-box {
  min-height: 60vh;
  max-height: 60vh;
}
</style>